<template>
  <div class="fluid" id="reasonList">
    <div>
      <div class="mms-reason-list-dev">
        <v-card elevation="0" class="px-3 py-2">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="position:relative;padding:0 20px;text-align:center;margin-top:20px;"
            >
              <h4 class="indigo--text" style="font-weight:bold;margin:auto;">
                MASTER REASON
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDataFromApi"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <div>
                <v-toolbar
                  class="mms-reason-list-toolbar-1"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0; padding-top:15px;"
                >
                  <div class="d-flex align-content-start">
                    <div
                      style="margin-right:15px; height:45px;"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        style="
                      font-size: 12px;
                      "
                        @click="addReason"
                        elevation="2"
                        tilerounded="5px"
                        color="primary"
                        class="white--text"
                        small
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small class="">
                              mdi-plus
                            </v-icon>
                          </template>
                          <span>Add Reason</span>
                        </v-tooltip>
                      </v-btn>
                    </div>
                    <div style="width: 210px;">
                      <v-autocomplete
                        v-model="paramAPI.downtime_category_id"
                        label="Category"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="categoryWatcher"
                        :items="dropdown.category"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div style="width: 50%; margin-left:auto">
                    <v-text-field
                      v-model="paramAPI.keyword"
                      @keyup.enter="searchEnter"
                      label="Search here"
                      type="search"
                      append-icon="mdi-magnify"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </v-toolbar>
              </div>
            </v-col>

            <v-col cols="12">
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                height="50vh"
                :headers="headers"
                style="cursor: pointer;"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                @update:page="updatePage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.no`]="{ index }">
                  <div
                    style="font-size:14px; padding: 0; display: flex; flex-direction: row;"
                  >
                    {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                  </div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    style="font-size:14px; padding: 0; display: flex; flex-direction: row; color:green;"
                  >
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.downtime_category_id`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ item.downtime_category_id }}
                  </div>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.createdAt) }}
                  </div>
                </template>
                <!-- <template v-slot:[`item.created_by_name`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ item.created_by_name }}
                  </div>
                </template> -->
                <template v-slot:[`item.updatedAt`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.updatedAt) }}
                  </div>
                </template>
                <!-- <template v-slot:[`item.updated_by_name`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ item.updated_by_name }}
                  </div>
                </template> -->
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }"
                      ><v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="rowClick(item)"
                        small
                        color="primary"
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="error"
                        @click.stop="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="reasonDialog" persistent max-width="400px">
      <v-card v-if="form !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Reason</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveReason">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    Name
                  </p>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.nameRules"
                    dense
                    outlined
                    style="height:45px;"
                  /> </v-col
                ><v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                  >
                    Category
                  </p>
                  <v-autocomplete
                    v-model="form.downtime_category_id"
                    label="Category"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    :items="dropdown.category"
                    :rules="rules.categoryRules"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeReason">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters /*  mapMutations mapActions */ } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  name: 'mmsmasterreason',
  data: () => ({
    editDialog: false,
    reasonDialog: false,
    // proc: buildType.apiURL('proc'),
    mms: buildType.apiURL('mms'),
    // eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      downtime_category_id: null
    },
    totalData: 0,
    form: null,
    sForm: null,
    detail: null,
    isEdit: false,

    options: {},
    actionValue: 0,
    headers: [
      {
        text: 'No',
        value: 'no',
        align: 'left',
        sortable: false
      },
      {
        text: 'Name',
        value: 'name',
        align: 'left',
        sortable: false
      },
      {
        text: 'Category',
        value: 'downtime_category_id',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'Status',
      //   value: 'status',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'Created at',
        value: 'createdAt',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'Created by',
      //   value: 'created_by_name',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'updated at',
        value: 'updatedAt',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'updated by',
      //   value: 'updated_by_name',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      }
    ],
    result: [],
    loading: false,
    rules: {
      nameRules: [],
      categoryRules: []
    },
    dropdown: {
      category: []
    },
    instance: null
  }),

  async mounted() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.paramAPI.department_id = this.getUserProfile.employee.department_id
    await this.getDataFromApi()
    await this.initDropdown()
  },
  computed: {
    // , 'getDropdownPlant'
    ...mapGetters(['getUserProfile'])
  },
  watch: {},
  methods: {
    // ...mapActions(['dropdownPlant']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.dropdownCategory()
    },
    searchEnter() {
      this.getDataFromApi()
    },
    categoryWatcher() {
      this.getDataFromApi()
    },

    async dropdownCategory() {
      await axios
        .get(`${this.mms}master/universal/downtimecategory/dropdown`)
        .then(res => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.dropdown.category = res.data.data)
          }
          return (this.dropdown.category = [])
        })
        .catch(err => {
          console.log(err)
          return (this.dropdown.category = [])
        })
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable().then(data => {
        console.log(data)
        setTimeout(() => {
          this.result = data.data
          this.totalData = data.total_record
          this.loading = false
        }, 1000)
      })
    },
    async initDataTable() {
      let url = `${this.mms}master/universal/downtimereason/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }`
      const filter = []
      if (this.paramAPI.downtime_category_id !== null) {
        filter.push(
          `{"downtime_category_id": ${this.paramAPI.downtime_category_id}}`
        )
      }
      url = url + `&filter=[${filter}]`
      return await new Promise(resolve => {
        axios
          .get(url)
          .then(res => {
            console.log(res)
            resolve(res.data)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    enableEdit() {
      var oldForm = this.form
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.form = oldForm
        if (this.form.act === 'add') {
          this.closeDialog()
        }
      }
    },

    rowClick(pItem) {
      console.log(pItem)
      this.form = {
        act: 'update',
        id: pItem.id,
        name: pItem.name,
        downtime_category_id: pItem.downtime_category_id
      }
      setTimeout(() => {
        this.reasonDialog = !this.reasonDialog
      }, 300)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async res => {
        if (res.isConfirmed) {
          await axios
            .delete(
              `${this.mms}master/universal/downtimereason/delete/${pItem.id}`
            )
            .then(async res => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch(err => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    closeDialog() {
      this.form = null
      this.detail = null
      this.isEdit = false
      setTimeout(() => {
        this.editDialog = false
      }, 300)
    },
    addReason() {
      this.form = {
        act: 'add',
        name: null,
        downtime_category_id: null
      }
      setTimeout(() => {
        this.reasonDialog = !this.reasonDialog
      }, 300)
    },
    saveReason() {
      this.rules.nameRules = [v => !!v || 'Name is required']
      this.rules.categoryRules = [v => !!v || 'Category is required']
      const self = this
      setTimeout(function() {
        if (self.$refs.entryForm2.validate()) {
          // self.createNewForm()
          const form = {
            act: self.form.act,
            name: self.form.name,
            downtime_category_id: self.form.downtime_category_id
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }
          self.submitReason(form)
        }
      })
    },
    async submitReason(form) {
      await axios
        .post(`${this.mms}master/universal/downtimereason/save`, form)
        .then(async res => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
            this.closeReason()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch(err => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeReason() {
      this.form = null
      setTimeout(() => {
        this.reasonDialog = false
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#reasonList {
  position: relative;
  .mms-reason-list-dev {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .mms-reason-list-toolbar-1 {
      .mms-reason-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .activity-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #reasonList {
    .mms-reason-list-dev {
      .mms-reason-list-toolbar-1 {
        .mms-reason-list-toolbar-1 {
          display: none;
        }
      }
      .activity-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
